import { render, staticRenderFns } from "./InventoryManageDetail.vue?vue&type=template&id=c5020c90&scoped=true"
import script from "./InventoryManageDetail.vue?vue&type=script&lang=js"
export * from "./InventoryManageDetail.vue?vue&type=script&lang=js"
import style0 from "./InventoryManageDetail.vue?vue&type=style&index=0&id=c5020c90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5020c90",
  null
  
)

export default component.exports